module.exports = __webpack_public_path__ + "img/sniperrifle.845062ca.svg";